import React, { useState, useEffect } from 'react';
import { Paper, Box } from '@mui/material';
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';
import MenuIcon from '@mui/icons-material/Menu';
import { useApp } from '../context/AppContext';
import { useLanguage } from '../context/LanguageContext';

export default function BottomNavigationBar({ onMoreClick, isInlineMenuFooter = false }) {
    const { activeView, setActiveView, setCheckoutMode, fetchFreshTablesAndOrders, setSidebarMobileOpen } = useApp();
    const { currentLanguage } = useLanguage();
    
    // Auto-select tab based on active view
    const [value, setValue] = useState(activeView === 'tables' ? 'tables' : 'other');

    useEffect(() => {
        if (activeView === 'tables') {
            setValue('tables');
        } else {
            setValue('other');
        }
    }, [activeView]);

    const handleChange = (event, newValue) => {
        if (newValue === 'tables') {
            if (typeof setCheckoutMode === 'function') setCheckoutMode(false);
            if (typeof setActiveView === 'function') setActiveView('tables');
            setValue('tables');
            if (typeof fetchFreshTablesAndOrders === 'function') {
                fetchFreshTablesAndOrders(true).catch(err => console.warn("Auto refresh tables:", err));
            }
        } else if (newValue === 'more') {
            if (typeof onMoreClick === 'function') {
                onMoreClick();
            } else if (typeof setSidebarMobileOpen === 'function') {
                setSidebarMobileOpen(true);
            }
        }
    };

    // Helper for labels
    const getLabel = (type) => {
        if (currentLanguage === 'mr' || currentLanguage === 'hi') {
            if (type === 'tables') return 'टेबल्स (Tables)';
            if (type === 'more') return 'अधिक (More)';
        } else {
            if (type === 'tables') return 'Tables';
            if (type === 'more') return 'More';
        }
    };

    const paperStyles = isInlineMenuFooter ? {
        position: 'static',
        width: '100%',
        borderRadius: 2.5,
        overflow: 'hidden',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        my: 1,
        display: 'block'
    } : {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1150,
        boxShadow: '0 -4px 15px rgba(0,0,0,0.15)',
        display: 'block'
    };

    return (
        <Paper sx={paperStyles} elevation={isInlineMenuFooter ? 2 : 6}>
            <Box sx={{ display: 'flex', width: '100%', height: isInlineMenuFooter ? 48 : 56 }}>
                {/* 1. Tables Button (Red - Left 50%) */}
                <Box
                    onClick={(e) => handleChange(e, 'tables')}
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: isInlineMenuFooter ? 'row' : 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: isInlineMenuFooter ? 1 : 0.3,
                        bgcolor: value === 'tables' ? '#dc2626' : '#ef4444',
                        borderRight: '1.5px solid rgba(255,255,255,0.3)',
                        cursor: 'pointer',
                        color: '#ffffff',
                        transition: 'all 0.2s',
                        opacity: value === 'tables' ? 1 : 0.88,
                        '&:hover': { bgcolor: '#b91c1c', opacity: 1 },
                        '&:active': { transform: 'scale(0.98)' }
                    }}
                >
                    <TableRestaurantIcon sx={{ fontSize: isInlineMenuFooter ? 20 : 22 }} />
                    <span style={{ fontSize: '0.85rem', fontWeight: 900, letterSpacing: '0.3px' }}>{getLabel('tables')}</span>
                </Box>

                {/* 2. More Button (Blue - Right 50%) */}
                <Box
                    onClick={(e) => handleChange(e, 'more')}
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: isInlineMenuFooter ? 'row' : 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: isInlineMenuFooter ? 1 : 0.3,
                        bgcolor: value === 'more' ? '#1d4ed8' : '#2563eb',
                        cursor: 'pointer',
                        color: '#ffffff',
                        transition: 'all 0.2s',
                        opacity: value === 'more' ? 1 : 0.88,
                        '&:hover': { bgcolor: '#1e40af', opacity: 1 },
                        '&:active': { transform: 'scale(0.98)' }
                    }}
                >
                    <MenuIcon sx={{ fontSize: isInlineMenuFooter ? 20 : 22 }} />
                    <span style={{ fontSize: '0.85rem', fontWeight: 900, letterSpacing: '0.3px' }}>{getLabel('more')}</span>
                </Box>
            </Box>
        </Paper>
    );
}
